import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextArea, ContextualAlert } from '@paypalcorp/pp-react';
import templateData from '../../../utility/getTemplateData';
import { byteLength } from '../../utils/clientValidatorUtils';
import { trackEventWithData } from '../../utilsV3/analytics';
import { FPTI_SPEC } from '../../utilsV3/fptiConstants';

const TextAreaWithByteCounter = (props) => {
  const initialByteCount = props.input.value
    ? byteLength(props.input.value)
    : 0;
  const [byteCount, setByteCount] = useState(initialByteCount);
  const textAreaEl = useRef(null);

  const directionality = templateData.contextLocalityDir;
  const maxByteLimit = props.maxByteLimit;
  const counterAriaLabel = props.counterLabel
    .replace('{byteCount}', byteCount)
    .replace('{maxByteCount}', maxByteLimit);
  const errorText = props.meta.error;

  const handleChange = (event) => {
    const value = event.target.value;
    const byteLengthOfValue = byteLength(value);
    setByteCount(byteLengthOfValue);
    props.input.onChange(event);
  };

  useEffect(() => {
    if (errorText) {
      trackEventWithData(FPTI_SPEC.FIELD_LEVEL_ERROR_IM, {
        error_code: 'INPUT_FIELD_VALIDATION_ERROR',
        error_desc: props.id,
        error_detail: errorText,
      });
    }
  }, [errorText]);

  return (
    <div className="text-input-byte-counter">
      <div
        className={`textarea-counter-wrapper ${
          errorText ? 'textarea-counter-wrapper-error' : ''
        }`}
      >
        <TextArea
          label={props.textLabel}
          maxRows={2}
          minRows={2}
          maxCharacters={maxByteLimit}
          dir={directionality}
          value={props.input.value}
          onChange={handleChange}
          className="textarea-holder"
          ref={textAreaEl}
          id={props.id}
        />
        <div
          className={`counter-text ${errorText ? 'counter-text-error' : ''}`}
          role="status"
          aria-label={counterAriaLabel}
          onClick={() => textAreaEl.current.focus()}
        >
          {`${byteCount}/${maxByteLimit}`}
        </div>
      </div>
      {errorText && (
        <ContextualAlert type="error" className="byte-text-area-error">
          {errorText}
        </ContextualAlert>
      )}
    </div>
  );
};

TextAreaWithByteCounter.propTypes = {
  input: PropTypes.object,
  maxByteLimit: PropTypes.number,
  counterLabel: PropTypes.string,
  errorMsg: PropTypes.string,
  textLabel: PropTypes.string,
  id: PropTypes.string,
  meta: PropTypes.object,
};

export default TextAreaWithByteCounter;
